import Axios, { AxiosRequestConfig } from "axios";
import store from "../store";
import { AuthService } from "../Services/AuthService";
export const AXIOS_INSTANCE = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

AXIOS_INSTANCE.interceptors.request.use(
  (config) => {
    const token = store?.getState()?.user?.token;

    if (token) {
      config.headers.Authorization = `Bearer  ${token}`;
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Don't retry certain endpoints
    const url = originalRequest.url?.toLowerCase() || "";
    const isBlacklisted =
      url.includes("/login") ||
      url.includes("/logout") ||
      url.includes("/refresh");
    // ||url.includes("/verify2fa");

    if (isBlacklisted) return Promise.reject(error);

    // ---- Handle 401 ----
    console.log("here 1");
    
    if (error.response?.status === 401) {
    console.log("here 2");

      console.log(await AuthService.logout());
      throw error;
    }

    return Promise.reject(error);
  }
);

export const customAxios = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };

  return promise;
};
